import React from 'react';
import { BsTwitter, BsInstagram, BsGithub } from 'react-icons/bs';
// import { FaFacebookF } from 'react-icons/fa';
import { FaLinkedinIn } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://twitter.com/rrgindeed" target='_blank' rel="noreferrer">
        <BsTwitter />
      </a>
    </div>
    <div>
      <a href="https://github.com/RiddhiRaj" target='_blank' rel="noreferrer">
        <BsGithub />
      </a>
    </div>
    <div>
      <a href="https://in.linkedin.com/in/riddhi-raj-ghosh-4503b1229?trk=people-guest_people_search-card" target='_blank' rel="noreferrer">
        <FaLinkedinIn />
      </a>
    </div>
    <div>
      <a href="https://instagram.com/rrgindeed" target="_blank" rel='noreferrer'>
        <BsInstagram />
      </a>
    </div>
  </div>
);

export default SocialMedia;